import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { connect } from 'react-redux';
import types from 'prop-types';
import { branch, compose, withState, withHandlers, mapProps, setDisplayName } from 'recompose';
import _ from 'lodash';
var withA11y = compose(setDisplayName('behaviour(A11Y)'), withHandlers({
  onFocus: function onFocus(_ref) {
    var shouldSelectOnFocus = _ref.shouldSelectOnFocus,
        _ref$onFocus = _ref.onFocus,
        _onFocus = _ref$onFocus === void 0 ? _.noop : _ref$onFocus;

    return function (e) {
      _onFocus(e);

      if (!e.defaultPrevented && shouldSelectOnFocus) e.target.select();
    };
  }
}), mapProps(function (_ref2) {
  var appLayer = _ref2.appLayer,
      layer = _ref2.layer,
      isFocused = _ref2.isFocused,
      shouldSelectOnFocus = _ref2.shouldSelectOnFocus,
      _ref2$__segments = _ref2.__segments,
      __segments = _ref2$__segments === void 0 ? {} : _ref2$__segments,
      props = _objectWithoutProperties(_ref2, ["appLayer", "layer", "isFocused", "shouldSelectOnFocus", "__segments"]);

  if (isFocused) {
    __segments.container = (__segments.container || []).concat('containerFocused');
  }

  return _objectSpread({}, props, {
    isFocused: isFocused,
    tabIndex: appLayer === layer ? props.tabIndex || 0 : -1,
    __segments: __segments
  });
}));
var uncontrolled = compose(setDisplayName('behaviour(A11Y(Uncontrolled))'), withState('isFocused', 'setFocus', false), withHandlers({
  onFocus: function onFocus(_ref3) {
    var setFocus = _ref3.setFocus,
        _ref3$onFocus = _ref3.onFocus,
        _onFocus2 = _ref3$onFocus === void 0 ? _.noop : _ref3$onFocus;

    return function (e) {
      _onFocus2(e);

      !e.defaultPrevented && setFocus(true);
    };
  },
  onBlur: function onBlur(_ref4) {
    var setFocus = _ref4.setFocus,
        _ref4$onBlur = _ref4.onBlur,
        _onBlur = _ref4$onBlur === void 0 ? _.noop : _ref4$onBlur;

    return function (e) {
      _onBlur(e);

      !e.defaultPrevented && setFocus(false);
    };
  }
}), mapProps(function (_ref5) {
  var setFocus = _ref5.setFocus,
      props = _objectWithoutProperties(_ref5, ["setFocus"]);

  return props;
}), withA11y);
export default compose(branch(function (_ref6) {
  var uncontrolled = _ref6.uncontrolled;
  return uncontrolled;
}, uncontrolled, withA11y));
export var withAppLayer = connect(function (_ref7) {
  var layer = _ref7.ui.layer;
  return {
    appLayer: layer
  };
});
export var propTypes = {
  isFocused: types.bool,
  shouldSelectOnFocus: types.bool,
  appLayer: types.number,
  layer: types.number
};